import { render, staticRenderFns } from "./ModalOsAVencer.vue?vue&type=template&id=6c0c0e3a&scoped=true&"
import script from "./ModalOsAVencer.vue?vue&type=script&lang=js&"
export * from "./ModalOsAVencer.vue?vue&type=script&lang=js&"
import style0 from "./ModalOsAVencer.vue?vue&type=style&index=0&id=6c0c0e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c0e3a",
  null
  
)

export default component.exports